import React from 'react';

import SvgIcon from '~/components/core/SvgIcon';
import type { IconProps } from '~/components/icons/types';

const PageMenuIcon: React.FC<IconProps> = (props) => (
  <SvgIcon viewBox="0 0 17 14" stroke="none" {...props}>
    <path
      d="M15 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V12.5C0 12.8315 0.131696 13.1495 0.366116 13.3839C0.600537 13.6183 0.918479 13.75 1.25 13.75H15C15.3315 13.75 15.6495 13.6183 15.8839 13.3839C16.1183 13.1495 16.25 12.8315 16.25 12.5V1.25C16.25 0.918479 16.1183 0.600537 15.8839 0.366116C15.6495 0.131696 15.3315 0 15 0ZM15 1.25V4.375H1.25V1.25H15ZM1.25 5.625H5.625V12.5H1.25V5.625ZM15 12.5H6.875V5.625H15V12.5Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default PageMenuIcon;
